
<template>
  <div
    :class="[isModalOpen ? 'd-flex ': 'd-none']"
    class="size-modal image-modal-wrapper generic-modal position-fixed align-items-center justify-content-center position-fixed "
    style="font-size:16px">
    <div class="modal-inner  align-items-center justify-content-center d-flex h-100 w-100">
      <div class="bm-modal-content bg-white px-24 pt-20  pb-xl-35 pb-lg-29 pb-md-29 position-fixed rounded rounded-4 pt-xl-26 pt-lg-20" >
        <div
          class="p-0 border-0 text-end close-icon-wrapper custom-icon position-absolute"
          @click="handleModalClose">
          <icon name="close-icon"/>
        </div>
        <div class="bm-modal-body border-0 mt-3">
          <h2 class="text-center modal-heading text-dark-gray fs-20 mb-0">Add QR Code</h2>
          <div class="main-tabs-content mt-20">

            <div class="row">
              <div class="form-group">
                <label for="size-name">Add a URL</label>
                <input
                  v-model="url"
                  type="text"
                  class="form-control  form-control-lg"
                  placeholder="www.example.com"
                  @click.stop
                >

                <div
                  v-if="!isValidURL && url.length > 0"
                  class="text-danger" >
                  <small>URL is not valid</small>
                </div>
                <div
                  v-if="isValidURL"
                  class="text-success" >
                  <small>URL is valid </small>

                </div>
              </div>
            </div>
            <div
              class="row d-flex justify-content-center preview-div mt-20 mb-20"
              v-html="generatedSVG"/>

          </div>
        </div>
        <div
          class="bm-modal-footer mt-xl-30 mt-lg-24  mt-md-24 d-flex justify-content-between align-items-center">

          <button
            class="lf-btn red-border-btn action-btn bg-white"
            @click="handleModalClose">Cancel</button>
          <button
            :disabled="(!isValidURL)"
            class="lf-btn blue-border-btn action-btn bg-white"
            @click.stop="addQRCode">Preview</button>
          <button
            :disabled="(!isValidURL)"
            class="bm-primary-btn action-btn"
            @click.stop="insertQRCode">Insert</button>

        </div>
      </div>
    </div>
    <div
      class="backdrop position-fixed h-100 w-100"
      @click="handleModalClose"
    />
  </div>
</template>
<script>
import QRCode from 'qrcode-svg';
import EventBus from '@/EventBus';
import validator from 'validator';
import url from 'url';

export default {
  data() {
    return {
      url:          '',
      generatedSVG: '',
    };
  },
  computed: {
    isModalOpen() {
      return this.$store.getters.getDisplayQRCodeModal;
    },
    isValidURL() {
      return validator.isURL(this.url);
    },
  },
  methods: {
    handleModalClose() {
      this.generatedSVG = '';
      this.$store.commit('setDisplayQRCodeModal', false);
    },


    addQRCode() {
      if (!this.isValidURL) { return; }
      const svg         = new QRCode({
        content:        this.url,
        padding:        0,
        width:          256,
        height:         256,
        color:          '#000000',
        background:     'transparent',
        join:           false,
        xmlDeclaration: false,
      }).svg();
      this.generatedSVG = svg;
    },
    insertQRCode() {
      if (!this.isValidURL) { return; }

      let svg = new QRCode({
        content:        this.url,
        padding:        0,
        width:          256,
        height:         256,
        color:          '#000000',
        background:     null,
        join:           true,
        xmlDeclaration: false,
      }).svg();

      const div     = document.createElement('div');
      div.innerHTML = svg.trim();
      svg           = div.firstChild;

      svg.removeChild(svg.firstElementChild);
      svg.style.transformOrigin = 'left top';
      svg                       = svg.outerHTML;
      this.generatedSVG         = svg;
      let layerName             = '';
      try {
        const path = url.parse(this.url);
        layerName  = `QR-${path.hostname.replace('www.', '').substring(0, 10)}`;
      } catch (ex) {
        console.log('qr code name issue', ex.message);
        layerName = `QR-${this.url.replace('www.', '').substring(0, 10)}`;
      }
      EventBus.$emit('AddSvgShape', {
        content: svg, name:    layerName, color:   'rgb(0,0,0)', width:   256, height:  256,
      });
      this.handleModalClose();
    },
  },
};

</script>
<style  lang="scss">
  .generic-modal{
    .bm-modal-content{
      max-height: none !important;
      height: auto;
      width: 34vw !important;
      min-width: 0;
      .preview-div{
        svg{
          width: 275px;
          height: 275px;
        }
      }
      .bm-modal-footer{
        max-width: 100%;
        justify-content: space-evenly;
      }
    }
    .close-icon-wrapper{
      top: 10px;
      right: 10px;
    }
  }

  @media screen and (max-width: 1285px){
  .bm-modal-content  .fs-20{
      font-size: 18px !important;
    }

  }
  .div-wrapper{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: -5px !important;
  }
  .input-field{
    font-size: 16px;
    width: 80px;
    height: 37px;
    margin-right: 10px;
    text-align: center;
    border: 1px solid #ededed;
  }
  .input-name-field{
    font-size: 16px;
    width: 180px;
    height: 35px;
    margin-left: 10px;
    text-align: center;
    border: 1px solid #ededed;
  }
</style>
